import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const ModalitySchema = BaseSchema.extend({
  name: z.string().max(255),
  shortcut: z.string().max(255),
});

export type Modality = z.infer<typeof ModalitySchema>;

export const ModalityEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: ModalitySchema,
});

export type ModalityEntityQueryResult = z.infer<typeof ModalityEntityQueryResultSchema>;
